module.exports = __webpack_public_path__ + "img/13.f95c66f0.jpg";